import { Flex } from 'foundations-components/components/Flex';
import SkeletonBase from '../../_core/common/components/loading/SkeletonBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingBanner = ({
  marginStyle
}) => {
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    justifyContent: "center",
    alignItems: "center",
    paddingBlock: "400",
    paddingInline: "500",
    backgroundColor: "fill-surface-default",
    borderColor: "border-core-subtle",
    borderWidth: "100",
    borderRadius: "transitional-component",
    borderStyle: "solid",
    role: "alert"
  }, marginStyle, {
    children: [/*#__PURE__*/_jsx(SkeletonBase, {
      circleSize: "24px",
      shape: "circle",
      wrapperWidth: "auto"
    }), /*#__PURE__*/_jsx(SkeletonBase, {
      height: "12px",
      marginStyle: {
        marginInlineStart: '400'
      }
    })]
  }));
};
export default LoadingBanner;